import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeTravelPlan from './ChangeTravelPlan';
import ChangeTravelDestination from './ChangeTravelDestination';
import ChangeTravelTime from './ChangeTravelTime';
import ChangeTravelCoverage from './ChangeTravelCoverage';
import ChangeTravelHelper from './ChangeTravelHelper';
import ChangeTravelPassenger from './ChangeTravelPassenger';
import ChangePriceTravel from './ChangePriceTravel';



const styles = theme => ({
  paperrtl: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }
  , paper: {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(20),
      },
    },


});

class ChangeTravel extends Component {
  cookies=new Cookies();
  constructor(props) {
      super(props);
    this.state = {
  value:0,
}}

componentDidMount() {

}
handleChange= (event,newValue) => {
  this.setState({ value:newValue });
}
    render() {
      const { classes } = this.props;
      const { value } = this.state;

        return (
            <div>
                 <AppBar position="sticky"color="primary" >

                   <Tabs
                    style={{height:'60px',textAlign:'center'}}
                     value={value}
                     onChange={this.handleChange}
                     indicatorColor="secondary"
                     textColor={'#000000'}
                     variant="scrollable"
                     scrollButtons="auto"
                     aria-label="scrollable auto tabs example"
                   >
                     <Tab label="طرح مسافرتی"  />
                     <Tab label="مقصد مسافرتی"  />
                     <Tab label="زمان مسافرت"  />
                     <Tab label="پوشش بیمه مسافرتی"  />
                     <Tab label="کمک رسان"  />
                     <Tab label="مسافران "  />
                     <Tab label="قیمت بیمه مسافرتی "  />
                     </Tabs>


                 </AppBar>
                 {(value===0)?<ChangeTravelPlan  props={this.props}/>:null}
                 {(value===1)?<ChangeTravelDestination  props={this.props}/>:null}
                 {(value===2)?<ChangeTravelTime  props={this.props}/>:null}
                 {(value===3)?<ChangeTravelCoverage  props={this.props}/>:null}
                 {(value===4)?<ChangeTravelHelper  props={this.props}/>:null}
                 {(value===5)?<ChangeTravelPassenger  props={this.props}/>:null}
                 {(value===6)?<ChangePriceTravel  props={this.props}/>:null}

               </div>
        );
    }
}

export default  withStyles(styles)(ChangeTravel);
